import * as React from 'react'
import NumberFieldInnerTable from '../../inputs/NumberFieldInnerTable'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const TaxesInclude = ({ data, setData }) => {
  const { t } = useLocalize()
  // @TODO ADD CURRENCY
  return (
    <div className="tw-flex tw-items-end tw-justify-between tw-gap-2 tw-px-5 tw-pt-3">
      <div className="tw-text-sm tw-text-content-base">
        <p>{t('contract.income-after-deductions')}</p>
        <p>01-01-2025 -</p>
        <p> 30-11-2026</p>
      </div>
      <NumberFieldInnerTable
        innerLabel="PLN"
        placeholder="0,00"
        value={(data?.taxBase && data?.taxBase.toString()) || ''}
        onChange={(e) => {
          setData({ ...data, taxBase: Number(e.target.value) })
        }}
      />
    </div>
  )
}

export default TaxesInclude
